import React, { Component } from 'react'
import { Popup } from 'devextreme-react/popup'
import Form from 'devextreme-react/form'
import DevExpressDataGrid from 'components/inheritComponent/devexpressdatagrid'
import FormPembayaranTagihan from './formPembayaranTagihan'
import { alert } from 'devextreme/ui/dialog'
import { confirmAlert } from 'react-confirm-alert'
import httpRequest from 'plugin/httprequest'
import notify from 'devextreme/ui/notify'
import { months } from 'dataSource/lookup'

class ModalPembayaranTagihan extends Component {
  constructor(props) {
    super(props)

    this.state = {
      popupVisible: false,
      dataParent: {},
    }

    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)

    this.PopupRef = React.createRef()
    this.formPembayaranTagihanParentRef = React.createRef()
    this.showModalFormPembayaranRef = React.createRef()
    this.showModalDetailPembayaranRef = React.createRef()
    this.dataGridRef = React.createRef()
    this.columns = [
      {
        type: 'buttons',
        buttons: [
          {
            text: 'Kirim',
            hint: 'kirim',
            onClick: async (e) => {
              if (e.row.data.statusId !== 1) {
                alert('Data Sudah Dikirim!', 'Infromasi!')
                return
              }
              confirmAlert({
                title: 'Konfirmasi',
                message: 'Apakah anda yakin mengirim data ini ?.',
                overlayClassName: 'react-custom-confirm-alert-overlay',
                closeOnClickOutside: false,
                buttons: [
                  {
                    label: 'Iya',
                    className:
                      'bg-button-popup-save-dapen-default text-uppercase w-25 font-weight-bold',
                    onClick: () => {
                      this.sendData(e.row.key)
                    },
                  },
                  {
                    label: 'Batal',
                    className:
                      'bg-button-popup-close-dapen-default text-uppercase w-25 font-weight-bold',
                    onClick: () => {
                      return false
                    },
                  },
                ],
              })
            },
          },
          {
            text: 'Detail',
            hint: 'Detail',
            onClick: async (e) => {
              this.showModalDetailPembayaranRef.current.show()
              this.showModalDetailPembayaranRef.current.retrieveData(
                this.state.dataParent,
                e.row.key
              )
            },
          },
        ],
      },
      {
        dataField: 'rowNumber',
        caption: 'No.',
        cellRender: (data) => {
          return data.rowIndex + 1
        },
      },
      {
        dataField: 'payDate',
        caption: 'Tanggal Pembayaran',
        dataType: 'date',
        format: 'dd MMM yyyy',
      },
      {
        dataField: 'payAmount',
        caption: 'Nominal Pembayaran',
        dataType: 'number',
        format: '#,##0.00',
        alignment: 'right',
      },
      {
        dataField: 'fileName',
        caption: 'File',
      },
      {
        dataField: 'status',
        caption: 'Status',
      },
    ]
    this.formItems = [
      {
        itemType: 'group',
        caption: 'Periode Iuran',
        cssClass: 'group-radius',
        items: [
          {
            dataField: 'invoiceNo',
            label: {
              text: 'No Invoice',
            },
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
              deferRendering: false,
              readOnly: true,
            },
          },
          {
            dataField: 'productName',
            label: {
              text: 'Produk',
            },
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
              deferRendering: false,
              readOnly: true,
            },
          },
          {
            dataField: 'tahun',
            label: {
              text: 'Iuran Tahun',
            },
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
              deferRendering: false,
              readOnly: true,
            },
          },
          {
            dataField: 'bulan',
            label: {
              text: 'Bulan',
            },
            editorType: 'dxSelectBox',
            editorOptions: {
              elementAttr: {
                class: 'bd-input-popup-disabled-dapen-default',
                style: 'margin-bottom: 2.8rem !important',
              },
              dataSource: months(),
              valueExpr: 'id',
              displayExpr: 'value',
              searchEnabled: true,
              deferRendering: false,
              readOnly: true,
            },
          },
        ],
      },
      {
        itemType: 'group',
        caption: 'Outstanding Iuran',
        cssClass: 'group-radius',
        items: [
          {
            dataField: 'invoiceDate',
            label: {
              text: 'Tanggal Invoice',
            },
            editorType: 'dxDateBox',
            editorOptions: {
              displayFormat: 'dd MMM yyyy',
              useMaskBehavior: true,
              openOnFieldClick: true,
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
              readOnly: true,
            },
          },
          {
            dataField: 'dueDate',
            label: {
              text: 'Tanggal Jatuh Tempo',
            },
            editorType: 'dxDateBox',
            editorOptions: {
              displayFormat: 'dd MMM yyyy',
              useMaskBehavior: true,
              openOnFieldClick: true,
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
              readOnly: true,
            },
          },
          {
            dataField: 'invoiceNominal',
            label: {
              text: 'Total Tagihan',
            },
            editorType: 'dxNumberBox',
            editorOptions: {
              format: '#,##0.00',
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
            },
          },
          {
            dataField: 'paidAmount',
            label: {
              text: 'Total Di Bayarkan',
            },
            editorType: 'dxNumberBox',
            editorOptions: {
              format: '#,##0.00',
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
            },
          },
          {
            dataField: 'outstandingAmount',
            label: {
              text: 'Outstanding Pembayaran',
            },
            editorType: 'dxNumberBox',
            editorOptions: {
              format: '#,##0.00',
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
            },
          },
        ],
      },
    ]
  }

  get Popup() {
    return this.PopupRef.current.instance
  }

  getData = (data) => {
    this.formPembayaranTagihanParentRef.current.instance.updateData(data)
  }

  onToolbarPreparing = (e) => {
    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'plus',
        text: 'Tambah',
        elementAttr: { class: 'bg-button-add-dapen-default' },
        onClick: (e) => {
          this.showModalFormPembayaran()
        },
      },
    })
  }

  show() {
    this.setState({
      popupVisible: true,
    })
  }

  retrieveData(data) {
    const dueDate = new Date(data.invoiceDate)
    dueDate.setDate(dueDate.getDate() + 2)

    data.dueDate = dueDate.toISOString().split('T')[0]

    this.setState({
      dataParent: data,
    })
  }

  hide = async (e) => {
    this.setState({
      popupVisible: false,
      dataMaster: {},
    })
  }

  showModalFormPembayaran = () => {
    this.showModalFormPembayaranRef.current.show()
    this.showModalFormPembayaranRef.current.retrieveData(
      this.state.dataParent,
      null
    )
  }

  sendData = async (participantPaymentId) => {
    try {
      await httpRequest(
        process.env.REACT_APP_BACKEND_CORE,
        this.props.store,
        `wp/send-participant-payment/${participantPaymentId}`,
        'POST',
        {
          values: {},
        }
      )
      notify(
        {
          message: 'Pembayaran Tagihan berhasil dikirim!',
          width: 'AUTO',
          shading: true,
          position: { at: 'center', my: 'center', of: window },
        },
        'success',
        600
      )
      this.forceRefresh()
    } catch (error) {
      console.error(error)
      notify(
        {
          message: 'Terjadi Kesalahan!',
          width: 'AUTO',
          shading: true,
          position: { at: 'center', my: 'center', of: window },
        },
        'error',
        600
      )
    }
  }

  forceRefresh = () => {
    this.dataGridRef.current.forceRefresh(true)
  }

  renderElement = () => {
    return (
      <div>
        <Form
          ref={this.formPembayaranTagihanParentRef}
          colCount={2}
          id={'formPembayaranTagihanParent'}
          formData={this.state.dataParent}
          items={this.formItems}
          labelLocation="left"
        />
        <div className="row mt-3">
          <div className="col-12">
            <DevExpressDataGrid
              ref={this.dataGridRef}
              loadAPI={`wp/pembayaran-tagihans?invoiceId.equals=${this.state.dataParent.id}`}
              insertAPI="-"
              updateAPI="-"
              deleteAPI="-"
              backendserver={process.env.REACT_APP_BACKEND_CORE}
              allowAdding={false}
              allowDeleting={false}
              allowUpdating={false}
              exportExcel={false}
              exportFileName={'Daftar-Iuran'}
              allowExportSelectedData={true}
              showBorders={true}
              paging={false}
              defaultPageSize={10}
              popupTitle={'Daftar Iuran'}
              popupWidth={700}
              popupHeight={500}
              popupFormLabelLocation="left"
              popupFormMinColWidth={300}
              popupFormColCount={3}
              ColumnChooser={true}
              ColumnFixing={true}
              FilterRow={true}
              ColumnConfiguration={this.columns}
              onToolbarPreparing={this.onToolbarPreparing}
              height="40vh"
              store={this.props.store}
            />
          </div>
        </div>
        <FormPembayaranTagihan
          ref={this.showModalFormPembayaranRef}
          store={this.props.store}
          forceRefresh={this.forceRefresh}
          type="add"
        />
        <FormPembayaranTagihan
          ref={this.showModalDetailPembayaranRef}
          store={this.props.store}
          forceRefresh={this.forceRefresh}
          type="detail"
        />
      </div>
    )
  }

  render() {
    let elem = this.state.popupVisible && this.renderElement()
    return (
      <React.Fragment>
        <Popup
          className={'popup'}
          visible={this.state.popupVisible}
          onHiding={this.hide}
          dragEnabled={true}
          showTitle={true}
          title={`Pembayaran Tagihan`}
          width={'1000px'}
          height="auto"
          ref={this.PopupRef}
          toolbarItems={this.popupToolbarItem}
        >
          <div>{elem}</div>
        </Popup>
      </React.Fragment>
    )
  }
}

export default ModalPembayaranTagihan
